export default "__VITE_ASSET__Cp36zsG8__"